// Serves a smaller WebP version (pre-generated at build time for /hubs and
// /space-types assets) with automatic fallback to the original file.
// For known image CDNs (Pexels, Unsplash, ImageKit) it appends resize/compress
// params so we never ship a full-resolution original.
// It always sets width/height attributes so the browser reserves space before the
// image loads (prevents Cumulative Layout Shift / CLS).
// display:contents keeps layout identical to a bare <img>.

export function toWebp(src) {
  if (!src || typeof src !== "string") return null;
  if (!(src.startsWith("/hubs/") || src.startsWith("/space-types/"))) return null;
  return src.replace(/\.(jpe?g|png)$/i, ".webp");
}

export function optimizeCdn(src, width = 1200) {
  if (!src || typeof src !== "string" || !src.startsWith("http")) return src;
  try {
    const u = new URL(src);
    const host = u.hostname;
    if (host === "images.pexels.com") {
      u.searchParams.set("auto", "compress");
      u.searchParams.set("cs", "tinysrgb");
      u.searchParams.set("w", String(width));
      return u.toString();
    }
    if (host === "images.unsplash.com") {
      u.searchParams.set("auto", "format");
      u.searchParams.set("q", "75");
      u.searchParams.set("w", String(width));
      return u.toString();
    }
    if (host === "ik.imagekit.io") {
      if (!u.searchParams.has("tr")) u.searchParams.set("tr", `w-${width}`);
      return u.toString();
    }
    return src;
  } catch {
    return src;
  }
}

export function Picture({ src, alt = "", className, loading = "lazy", width = 1200, height, ...rest }) {
  const optimized = optimizeCdn(src, width);
  const webp = toWebp(src);
  const h = height || Math.round(width * 2 / 3);
  const img = (
    <img src={optimized} alt={alt} loading={loading} width={width} height={h} className={className} {...rest} />
  );
  if (!webp) return img;
  return (
    <picture style={{ display: "contents" }}>
      <source srcSet={webp} type="image/webp" />
      {img}
    </picture>
  );
}
